__webpack_require__.p = "https://webcdn.prodigygame.com/9368c06-582/";